import { useAxios } from "../../hooks/useAxios";
import { Topic } from "./topics";

// request + response types

type NoParams = Record<string, never>;

interface TopicPathParams {
  id: string;
}

interface CreateTopicParams {
  name: string;
  conversationId: string;
}

type TopicsEndpointConfig = {
  GET_TOPIC: EndpointConfig<
    TopicPathParams,
    Topic
  >;
  GET_TOPICS: EndpointConfig<
    NoParams,
    Topic[]
  >;
  CREATE_TOPIC: EndpointConfig<
    CreateTopicParams,
    Topic
  >;
  DELETE_TOPIC: EndpointConfig<
    TopicPathParams,
    null
  >;
};

// topics api specific logic

const requestInitialisers: RequestConfig<TopicsEndpointConfig> = {
  GET_TOPIC: (
    ({ id }) => ({
      url: `/topic/${id}`,
      method: "GET"
    })
  ),
  GET_TOPICS: (
    () => ({
      url: "/topic",
      method: "GET"
    })
  ),
  CREATE_TOPIC: (
    params => ({
      url: "/topic",
      method: "POST",
      data: params
    })
  ),
  DELETE_TOPIC: (
    ({ id }) => ({
      url: `/topics/${id}`,
      method: "DELETE"
    })
  )
};

export const useTopicsApi: UseApiRequest<TopicsEndpointConfig> = name => useAxios(requestInitialisers[ name ]);
